import { render } from "./MainServizi.vue?vue&type=template&id=8a57a222&scoped=true"
import script from "./MainServizi.vue?vue&type=script&lang=js"
export * from "./MainServizi.vue?vue&type=script&lang=js"

import "./MainServizi.vue?vue&type=style&index=0&id=8a57a222&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a57a222"]])

export default __exports__